import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

function NodeEditor({ node, onUpdate, onClose }) {
  const [nodeData, setNodeData] = useState({
    label: '',
    description: '',
    color: '',
    ...node?.data
  });

  useEffect(() => {
    if (node) {
      setNodeData({
        label: node.data?.label || '',
        description: node.data?.description || '',
        color: node.data?.color || '',
        ...node.data
      });
    }
  }, [node]);

  const handleChange = (field) => (event) => {
    setNodeData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleSave = () => {
    if (node) {
      onUpdate(node.id, nodeData);
    }
    onClose();
  };

  return (
    <Dialog open={Boolean(node)} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Edit Node
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Label"
            value={nodeData.label}
            onChange={handleChange('label')}
            fullWidth
          />
          <TextField
            label="Description"
            value={nodeData.description}
            onChange={handleChange('description')}
            multiline
            rows={4}
            fullWidth
          />
          <FormControl fullWidth>
            <InputLabel>Color</InputLabel>
            <Select
              value={nodeData.color || '#2196f3'}
              onChange={handleChange('color')}
              label="Color"
            >
              <MenuItem value="#2196f3">Blue</MenuItem>
              <MenuItem value="#4caf50">Green</MenuItem>
              <MenuItem value="#ff9800">Orange</MenuItem>
              <MenuItem value="#f44336">Red</MenuItem>
              <MenuItem value="#9c27b0">Purple</MenuItem>
              <MenuItem value="#607d8b">Grey</MenuItem>
              <MenuItem value="#e91e63">Pink</MenuItem>
              <MenuItem value="#00bcd4">Cyan</MenuItem>
              <MenuItem value="#795548">Brown</MenuItem>
              <MenuItem value="#ffc107">Amber</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={nodeData.status || 'pending'}
              onChange={handleChange('status')}
              label="Status"
            >
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="in-progress">In Progress</MenuItem>
              <MenuItem value="completed">Completed</MenuItem>
              <MenuItem value="error">Error</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NodeEditor;